import { Box, Typography } from '@mui/material'

export default function InsititutionsNotAssignedDialog() {
  return (
    <Box padding="40px 10px">
      <Typography variant="body2" textAlign="center">
        You have not been assigned to any institutions. Please contact your
        administrator.
      </Typography>
    </Box>
  )
}
